import { render, staticRenderFns } from "./HolidayListPage.vue?vue&type=template&id=84bf7910&scoped=true&"
import script from "./HolidayListPage.vue?vue&type=script&lang=ts&"
export * from "./HolidayListPage.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayListPage.vue?vue&type=style&index=0&id=84bf7910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bf7910",
  null
  
)

export default component.exports